import { Component, OnInit, Input, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { ErrorDefinition } from '../../models/error-definition';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports:[
    CommonModule,
    MatIconModule,
    MatCheckbox,
    MatFormField,
    MatInput,
    MatLabel,
    FormsModule,
    ReactiveFormsModule,
  ],
  encapsulation: ViewEncapsulation.None,
     
})
export class CheckboxInputComponent extends BaseInputDirective implements OnInit {
  @Input() hideReadOnlyNo: boolean = false;

  // when increasing checkbox size,
  // update x and y translate to fit in hover state.
  @Input() transformSize: number = 1;
  @Input() translateX: string = '0px';
  @Input() translateY: string = '0px';

  
 



  ngOnInit() {
    super.ngOnInit();

    if (this.formControl.value === null) {
      this.formControl.patchValue(false);
    }
    document.documentElement.style.setProperty('--check-box-scale', this.transformSize.toString());
    document.documentElement.style.setProperty('--translate-x', this.translateX);
    document.documentElement.style.setProperty('--translate-y', this.translateY);
  }

  getErrorDefinitions(): ErrorDefinition[] {
    return this.errorService.getGenericBoolErrors(this.formControl, this.fgInfo);
  }
}
